import { memo } from 'react'
import styled from 'styled-components'
import { ActiveFiltersCircle } from '@/features/shared/components/ActiveFiltersCircle'
import { TextButton } from '@shipt/design-system-buttons'
import { FilterIcon } from '@shipt/design-system-icons'
import { Headline } from '@shipt/design-system-typography'

type Props = {
  activeFiltersLength: number
  onClick: () => void
}

export const FilterTagSection = memo(({ activeFiltersLength, onClick }: Props) => (
  <Wrapper>
    <ContentWrapper>
      <FilterIcon />
      {activeFiltersLength > 0 && <FiltersCircle number={activeFiltersLength} />}
      <Headline size="md" as="span">
        Filters
      </Headline>
    </ContentWrapper>
    {activeFiltersLength > 0 && (
      <TextButton aria-label="clear all filters" onClick={onClick}>
        Clear filters
      </TextButton>
    )}
  </Wrapper>
))

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  svg {
    margin-right: 8px;
  }
`

const FiltersCircle = styled(ActiveFiltersCircle)`
  position: absolute;
  bottom: 8px;
  left: 8px;
`
